import $ from 'jquery';

export default function calendarModule() {
  const calendarElement = $('.js-datepicker');
  if (calendarElement.length) {
    return import(/* webpackChunkName: "calendar" */ '../calendar')
      .then(({ default: Calendar }) => {
        const calendar = new Calendar();
        return calendar;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
